// vehicle_id
import { useParams } from 'react-router-dom';

import VehicleList from './list';
import VehicleView from './view';

export default function UserIndex() {
  let { vehicle_id } = useParams();

  if (vehicle_id) {
    return <VehicleView />;
  } else {
    return <VehicleList />;
  }
}

